import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "LoadingAnimation",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },

  setup(_props, _ctx) {
    const svgLogo = ref(
      '<svg viewBox="0 0 235.42951 168.01981" ><g transform="translate(17.029961,-12.830276)" <ellipse style="opacity:0.277916;fill:#000000;fill-opacity:0;stroke:#006c00;stroke-width:1.5;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" ry="83.259903" rx="116.96475" cy="96.840179" cx="100.68479" /> <g transform="skewX(-15.14989)" aria-label="UHC"> <path d="m 89.276837,59.661187 v 42.167973 q 0,10.21953 -2.331641,15.23007 -2.33164,4.96094 -8.632031,8.18555 -6.250781,3.175 -16.023828,3.175 -9.773046,0 -15.577343,-2.87734 -5.754688,-2.87735 -8.632031,-8.18555 -2.877344,-5.3082 -2.877344,-15.52773 V 59.661187 h 17.214453 v 42.167973 q 0,5.45703 0.892969,8.03671 0.942578,2.57969 3.671093,4.11758 2.778125,1.48828 6.796485,1.48828 4.464843,0 7.242968,-1.48828 2.827735,-1.48828 3.720703,-3.91914 0.942578,-2.48047 0.942578,-8.23515 V 59.661187 Z" /> <path d="M 154.31473,59.661187 V 127.37798 H 138.73739 V 99.447905 H 117.55418 V 127.37798 H 101.97684 V 59.661187 h 15.57734 v 26.392187 h 21.18321 V 59.661187 Z" /> <path d="m 222.47801,84.862749 -16.61914,1.041797 q -0.34727,-14.337109 -11.16211,-14.337109 -12.40234,0 -12.40234,22.076172 0,12.749611 3.37343,17.313671 3.37344,4.51445 9.42578,4.51445 9.82266,0 12.00547,-12.79922 l 15.37891,0.94258 q -1.48828,12.1543 -9.07852,18.5043 -7.54062,6.30039 -18.50429,6.30039 -13.44414,0 -21.87774,-9.27695 -8.38398,-9.27696 -8.38398,-25.64805 0,-15.329296 8.13594,-25.102343 8.13593,-9.773047 22.225,-9.773047 24.40781,0 27.48359,26.243359 z" /></g></g></svg>',
    );

    return {
      svgLogo,
    };
  },
});
